module.exports = __webpack_public_path__ + "static/media/london-35.2bb86030.svg";